import { forwardRef } from "react";
import ReactDOM from "react-dom";

import styles from "./dropdown-portal.module.scss";

const highlightMatch = (name: string, inputValue: string) => {
    const lower = name.toLowerCase();
    const idx = lower.indexOf(inputValue.toLowerCase());
    if (idx === -1) return <>{name}</>;

    return (
        <>
            {name.substring(0, idx)}
            <strong>{name.substring(idx, idx + inputValue.length)}</strong>
            {name.substring(idx + inputValue.length)}
        </>
    );
};

export interface IDropdownPortalProps {
    options: string[];
    inputValue: string;
    anchorRect: DOMRect;
    onSelect: (name: string) => void;
}

export const DropdownPortal = forwardRef<HTMLUListElement, IDropdownPortalProps>(
    ({ options, inputValue, anchorRect, onSelect }, ref) => {
        return ReactDOM.createPortal(
            <ul
                className={styles.dropdown}
                style={{
                    position: "fixed",
                    top: anchorRect.bottom,
                    left: anchorRect.left,
                    width: anchorRect.width,
                }}
                ref={ref}
            >
                {options.map((name) => (
                    <li
                        key={name}
                        className={styles.dropdownItem}
                        onClick={() => onSelect(name)}
                    >
                        {highlightMatch(name, inputValue)}
                    </li>
                ))}
            </ul>,
            document.body
        );
    }
);
